import { lazy } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

const ServicesPage = lazy(() => import("@/pages/services/ServicesPage"));

export function ServiceRoutes() {
  return (
    <Route path="/services" element={<ProtectedRoute><ServicesPage /></ProtectedRoute>} />
  );
}
